import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {MainStoreService} from "@cybfed/core/store/main.store.service";
import {VideoPlayerComponent} from "@white-label/components/white-label/video-player/video-player.component";
import {CommonModule} from "@angular/common";
import {CardCarouselModel} from "@white-label/components/page-builder/models/card-carousel.model";
import {
    HorizontalCarouselComponent
} from "@white-label/components/carusels/horizontal-carousel/horizontal-carousel.component";
import {DefaultCardComponent} from "@white-label/components/page-builder/components/cards/default-card.component";
import {SafePipe} from "@cybfed/shared/pipes/safe.pipe";
import {CardTypes} from "@white-label/components/page-builder/models/card.model";
import {BlogCardComponent} from "@white-label/components/page-builder/components/cards/blog-card/blog-card.component";
import {TeamCardComponent} from "@white-label/components/page-builder/components/cards/team-card/team-card.component";
import {
    MediaCardComponent
} from "@white-label/components/page-builder/components/cards/media-card/media-card.component";
import {
    EventCardComponent
} from "@white-label/components/page-builder/components/cards/event-card/event-card.component";
import {
    FeatureCardComponent
} from "@white-label/components/page-builder/components/cards/feature-card/feature-card.component";

@Component({
    selector: 'white-label-horizontal-card-carousel',
    standalone: true,
    imports: [
        VideoPlayerComponent,
        CommonModule,
        HorizontalCarouselComponent,
        DefaultCardComponent,
        SafePipe,
        BlogCardComponent,
        TeamCardComponent,
        MediaCardComponent,
        EventCardComponent,
        FeatureCardComponent
    ],
    providers: [],
    templateUrl: './horizontal-car-carousel.component.html'
})
export class HorizontalCarCarouselComponent implements OnChanges{
    @Input() componentModel: CardCarouselModel =  new CardCarouselModel();
    constructor(public mainStore: MainStoreService) {
    }

    protected readonly CardTypes = CardTypes;
    protected readonly JSON = JSON;

    ngOnChanges(changes: SimpleChanges) {
    }
    trackByCardIndex(index: number, item: any): number {
        return item.id || index;
    }
}
